import DynamicWindowService from '@/core/application-dictionary/components/DynamicWindow/dynamic-window.service'
import Breadcrumb from '@/shared/components/Breadcrumb/index.vue'
import ChatRoom from '@/shared/components/ChatRoom/index.vue'
import ErrorLog from '@/shared/components/ErrorLog/index.vue'
import Hamburger from '@/shared/components/Hamburger/index.vue'
import HeaderSearch from '@/shared/components/HeaderSearch/index.vue'
import LangSelect from '@/shared/components/LangSelect/index.vue'
import Screenfull from '@/shared/components/Screenfull/index.vue'
import SizeSelect from '@/shared/components/SizeSelect/index.vue'
import { AccountStoreModule as accountStore } from '@/shared/config/store/account-store'
import { AppStoreModule as appStore } from '@/shared/config/store/app-store'
import { UserStoreModule as userStore } from '@/shared/config/store/user-store'
import lodash from 'lodash'
import { Component, Inject, Vue } from 'vue-property-decorator'

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    ErrorLog,
    Hamburger,
    HeaderSearch,
    LangSelect,
    Screenfull,
    SizeSelect,
    ChatRoom
  }
})
export default class extends Vue {

  displayChat: boolean= false;
  chatCounter: number= 0;

  @Inject("dynamicWindowService")
  private commonService: (baseApiUrl: string) => DynamicWindowService;

  debounceRetrieveChatCount:()=> void;

  mounted(): void{
    // console.log("mounted");
    if(this.userCanChat ) this.loopRetreiveChatCount();
  }

  created(){
    this.debounceRetrieveChatCount= lodash.debounce(this.retrieveUserChatCount, 1000);
  }

  loopRetreiveChatCount(): void {
    this.debounceRetrieveChatCount();
    
    setTimeout(()=> {
      this.loopRetreiveChatCount();
    }, 60000);
  }

  retrieveUserChatCount(): void {

    let userLoginId= accountStore.context.getters.account.id
      this.commonService(`api/m-chat-room-participants/count-unread/${userLoginId}`)
        .retrieve().then(res=> {
          // console.log({res});
          this.chatCounter= res.data;
    }).catch(()=> {});
  }


  get userCanChat(): boolean{
    let authority: string[]= accountStore.context.getters.account.authorities;
    console.log("authority ", {authority});
    return authority.includes("ROLE_SUPPLIER") || authority.includes("ROLE_BUYER") || authority.includes("ROLE_CHAT");
  }

  get sidebar() {
    return appStore.sidebar
  }

  get authenticated(): boolean {
    return accountStore.authenticated;
  }

  get device() {
    return appStore.device.toString()
  }

  get avatar() {
    return userStore.avatar
  }

  get username() {

    let account= accountStore.context.getters
    console.log("userdata ", {account});
    return accountStore.context.getters.account.login;
  }

  toggleSideBar() {
    appStore.ToggleSideBar(false);
  }

  async logout() {
    await accountStore.logout();
    
    this.$router.replace({
      path: `/redirect/login`
    })
    .catch(err => {
      console.warn(err);
    });
  }

  closeChat(){
    this.displayChat= false;
    this.debounceRetrieveChatCount();
  }
}